import { createSlice } from "@reduxjs/toolkit";
import { API_URL } from "config";
import { setFilters, setMaxPrice } from "features/Filters/filtersSlice";
import { ActiveFilter } from "features/Filters/types";
import {
  setTotalItems,
  setTotalPages,
} from "features/pagination/paginationSlice";
import { activeFiltersToURLParams } from "features/utils";
import { batch } from "react-redux";
import { RootState } from "store/rootReducer";
import { AccessoriesInitialState } from "./types";
import Axios from "axios";
import { SortingType } from "pages/category/types";

let initialState: AccessoriesInitialState = {
  accessories: [],
  isLoading: false,
  hasError: false,
};

const accessories = createSlice({
  name: "accessories",
  initialState,
  reducers: {
    setAccessories(state, action) {
      state.accessories = action.payload;
      state.isLoading = false;
    },
    setAccessoriesLoading(state, action) {
      state.isLoading = action.payload;
    },
    setAccessoriesHasError(state, action) {
      state.hasError = action.payload;
    },
  },
});

export const { setAccessories, setAccessoriesLoading, setAccessoriesHasError } =
  accessories.actions;

export const selectAccessories = (state: RootState) =>
  state.accessories.accessories;
export const selectAccessoriesLoading = (state: RootState) =>
  state.accessories.isLoading;
export const selectAccessoriesHasError = (state: RootState) =>
  state.accessories.hasError;

export const fetchFilteredAccessories =
  (
    activeFilters: ActiveFilter[],
    page: number = 1
    // activeCategorySortingType: string = SortingType.none
  ) =>
  async (dispatch: any) => {
    dispatch(setAccessoriesLoading(true));
    try {
      //TODO: sorting for accessories
      // const sort =
      //   activeCategorySortingType &&
      //   `${activeCategorySortingType
      //     .split(",")
      //     .map((item) => `&sort=${item}`)
      //     .join("")}`;
      const filtersAsParams = activeFiltersToURLParams(activeFilters);
      const response = await Axios.get(
        `${API_URL}/accessories?size=12&page=${page}&${filtersAsParams}`
      );

      batch(() => {
        dispatch(setAccessories(response.data.data));
        dispatch(setFilters(response.data.filters));
        dispatch(setMaxPrice(response.data.maxPrice));

        dispatch(setTotalPages(response.data.pages));
        dispatch(setTotalItems(response.data.data.length));
      });
    } catch (error: any) {
      // log error
      dispatch(setAccessoriesHasError(true));
    }
  };

export default accessories.reducer;
